import { useState } from "react";
import { ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { PageHeader } from "@/components/shared";
import { PublicLeadForm } from "@/components/PublicLeadForm";
import { CopyIframeButton } from "@/components/LeadEditDialog";
import { api, errMsg } from "@/lib/api";

export default function Forms() {
  const [key, setKey] = useState(0);
  const [busy, setBusy] = useState(false);
  const submit = async (f) => {
    setBusy(true);
    try {
      const r = await api.post("/public/leads", { ...f, source: "Lead Gen Form" });
      toast.success(`Lead ${r.data.leadNumber} created`);
      setKey((k) => k + 1);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div>
      <PageHeader title="Lead Form" subtitle="The PC build request form customers see on your website. Submitting it here creates a lead too.">
        <CopyIframeButton />
        <Button variant="outline" asChild><a href="/lead-form" target="_blank" rel="noreferrer" data-testid="open-public-form-link"><ExternalLink className="h-4 w-4 mr-2" />Open public page</a></Button>
      </PageHeader>
      <div className="rounded-lg border bg-white text-zinc-900 p-5 sm:p-10 max-w-[760px]" data-testid="forms-preview">
        <PublicLeadForm key={key} onSubmit={submit} busy={busy} />
      </div>
    </div>
  );
}
